/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTextProps } from './type';
const props: TdTextProps = {
  /** 是否添加代码样式 */
  code: {
    type: Boolean,
    value: false,
  },
  /** 文本内容 */
  content: {
    type: String,
  },
  /** 是否可复制 */
  copyable: {
    type: null,
    value: false,
  },
  /** 是否添加删除线样式 */
  delete: {
    type: Boolean,
    value: false,
  },
  /** 是否添加不可用样式 */
  disabled: {
    type: Boolean,
    value: false,
  },
  /** 是否省略展示，可通过配置参数自定义省略操作的具体功能和样式 */
  ellipsis: {
    type: null,
    value: false,
  },
  /** 文本是否为斜体 */
  italic: {
    type: Boolean,
    value: false,
  },
  /** 是否添加键盘样式 */
  keyboard: {
    type: Boolean,
    value: false,
  },
  /** 是否添加标记样式，默认为黄色，可通过配置颜色修改标记样式，如#0052D9 */
  mark: {
    type: null,
    value: false,
  },
  /** 文本是否加粗 */
  strong: {
    type: Boolean,
    value: false,
  },
  /** 主题 */
  theme: {
    type: String,
  },
  /** 是否添加下划线样式 */
  underline: {
    type: Boolean,
    value: false,
  },
};

export default props;
